
import "core-js/fn/string/includes";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
//import "./index.css";

import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
unregister();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js